__turbopack_context__.v({
  "animate-float": "Home-module__xMJmea__animate-float",
  "animate-float-delayed": "Home-module__xMJmea__animate-float-delayed",
  "centered": "Home-module__xMJmea__centered",
  "float": "Home-module__xMJmea__float",
  "float-delayed": "Home-module__xMJmea__float-delayed",
  "heroText": "Home-module__xMJmea__heroText",
  "thumbnailImg": "Home-module__xMJmea__thumbnailImg",
  "welcomeimg": "Home-module__xMJmea__welcomeimg",
  "welcomeimgpc": "Home-module__xMJmea__welcomeimgpc",
  "welcomepc": "Home-module__xMJmea__welcomepc",
});
